export default "__VITE_ASSET__IGWzZrAI__"